import React from "react";

// Logo örnekleri (şeffaf PNG / SVG önerilir)
import spada from "../../assests/images/partners/spadaLogo.png";
import kef from "../../assests/images/partners/kef.jpeg";
import skyplus from "../../assests/images/partners/skyplus.jpeg";
import cwwater from "../../assests/images/partners/CwWater_logo.png";

const partners = [
    { id: 1, name: "skyplus", logo: skyplus },
    { id: 2, name: "spada", logo: spada },
    { id: 3, name: "kef", logo: kef },
    { id: 4, name: "cwwater", logo: cwwater },
];

export default function PartnersSection() {
    return (
        <section className="partnersSection">
            <div className="container">
                <h2 className="partnersTitle">İş Ortaklarımız</h2>

                <div className="partnersGrid">
                    {partners.map((p) => (
                        <div className="partnerItem" key={p.id}>
                            <img src={p.logo} alt={p.name} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
